import { render, staticRenderFns } from "./CouponDialog.vue?vue&type=template&id=623a8b22&scoped=true&"
import script from "./CouponDialog.vue?vue&type=script&lang=js&"
export * from "./CouponDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a8b22",
  null
  
)

export default component.exports